import { BookOpen } from 'lucide-react';
import { ROUTES, USER_ROLES } from '../../utils/constants';

/** DEV_TEAM sidebar entry for Interactive Book Authoring (exported for tests). */
export const DEV_AUTHORING_SIDEBAR_ITEM = {
  labelKey: 'sidebar.dev.interactiveBookAuthoring',
  icon: BookOpen,
  route: ROUTES.DEV_AUTHORING_HOME,
  roles: [USER_ROLES.DEV_TEAM],
  activeRoutes: [
    ROUTES.DEV_AUTHORING_HOME,
    ROUTES.DEV_AUTHORING_BOOKS,
    ROUTES.DEV_AUTHORING_MIGRATION,
  ],
} as const;

export function isAuthoringSidebarActive(pathname: string): boolean {
  return DEV_AUTHORING_SIDEBAR_ITEM.activeRoutes.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}

export function devTeamNavIncludesAuthoring(
  navItems: ReadonlyArray<{ labelKey?: string; roles?: readonly string[] }>,
): boolean {
  return navItems.some((item) => item.labelKey === DEV_AUTHORING_SIDEBAR_ITEM.labelKey);
}
